import React, { useEffect, useState } from "react";
import SearchBar from "@mkyy/mui-search-bar";
import TabPanel from "@mui/lab/TabPanel";
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";
import CreateEditUserDialog from "../../../common/Dialogs/CreateEditUser";
import CreateEditUserDiscount from "../../../common/Dialogs/CreateEditDiscount";
import UsersTable from "../../../common/Tables/UsersTable";
import { privateAPI, publicAPI } from "../../../utils/api";
import { MuiButtonWrapper } from "../styles";

const AdminUsers = () => {
  const [loading, setLoading] = useState(true);
  const [allUsers, setAllUsers] = useState([]);
  const [rows, setRows] = useState([]);
  const [searched, setSearched] = useState("");
  const [userDTO, setUserDTO] = useState({});
  const [createUserOpen, setCreateUserOpen] = useState(false);
  const [createDiscountOpen, setCreateDiscountOpen] = useState(false);
  const [termsAndCond, setTermsAndCond] = useState(false);
  const [userDiscounts, setUserDiscounts] = useState([]);

  const requestSearch = (searchedVal) => {
    const filteredRows = allUsers.filter((row) => {
      return row.name.toLowerCase().includes(searchedVal.toLowerCase());
    });
    setRows(filteredRows);
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };

  const getAllUsers = async () => {
    setLoading(true);

    try {
      const response = await privateAPI.get(
        `/auth/bacchus/admin/users?status=APPROVED`
      );
      setAllUsers(response.data);
      setRows(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  };

  const closeCreateUserDialog = () => {
    setUserDTO({});
    setCreateUserOpen(false);
  };

  const closeCreateDiscountDialog = () => {
    setUserDiscounts([]);
    setCreateDiscountOpen(false);
  };

  const openDiscount = async (id) => {
    try {
      const [discounts, user] = await Promise.all([
        privateAPI.get(`/auth/bacchus/admin/product/discount/${id}`),
        privateAPI.get(`/auth/bacchus/client/user/${id}`)
      ]);
      setUserDiscounts(discounts.data);
      setUserDTO(user.data);
      setCreateDiscountOpen(true);
    } catch (error) {
      if (error.request.status === 500) return toast.error("Internal server error");
    }
  };

  const crateNewUser = async () => {
    if (!userDTO.name) return toast.info("Name is required");

    try {
      setLoading(true);
      userDTO.terms = termsAndCond;
      userDTO.userType = userDTO.company ? 'BUSINESS' : 'PRIVATE';
      await publicAPI.post(`/public/bacchus/registration`, userDTO);
      getAllUsers();
      setUserDTO({});
      setCreateUserOpen(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 409) return toast.error(`User is already exist`);
      if (error.request.status === 500) return toast.error("Internal server error");
    }
  };

  const editUser = async () => {
    if (!userDTO.name) return toast.info("Name is required!");

    try {
      setLoading(true);
      await privateAPI.put(`/auth/bacchus/admin/user/${userDTO.id}`, userDTO );
      getAllUsers();
      setUserDTO({});
      setCreateUserOpen(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500) return toast.error("Internal server error");
    }
  };

  const openEditUser = async (id) => {
    try {
      const response = await privateAPI.get(`/auth/bacchus/admin/user/${id}`);
      setUserDTO(response.data);
      setCreateUserOpen(true);
    } catch (error) {
      if (error.request.status === 500) return toast.error("Internal server error");
    }
  };

  const editDiscounts = async () => {
    try {
      setLoading(true);
      await privateAPI.post(`/auth/bacchus/admin/product/discount`, userDiscounts );
      closeCreateDiscountDialog();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500) return toast.error("Internal server error");
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    getAllUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setLoading(false);
  }, []);

  return (
    <TabPanel value="3">
      <MuiButtonWrapper>
        <Button
          variant="outlined"
          className="shadow-on-elements first-button"
          onClick={() => setCreateUserOpen(true)}
        >
          Add New User
        </Button>
        <Button
          variant="outlined"
          className="shadow-on-elements"
          onClick={() => getAllUsers()}
        >
          Reload Users
        </Button>
      </MuiButtonWrapper>
      <SearchBar
        value={searched}
        onChange={(searchVal) => requestSearch(searchVal)}
        onCancelSearch={() => cancelSearch()}
        style={{
          marginBottom: "30px",
          border: "1px solid #001753",
          boxShadow:
            "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
        }}
      />
      <UsersTable
        items={rows}
        openDiscount={openDiscount}
        openEditUser={openEditUser}
      />
      <CreateEditUserDialog
        open={createUserOpen}
        closeCreateUserDialog={closeCreateUserDialog}
        setUserDTO={setUserDTO}
        userDTO={userDTO}
        crateNewUser={crateNewUser}
        editUser={editUser}
        termsAndCond={termsAndCond}
        setTermsAndCond={setTermsAndCond}
      />
      <CreateEditUserDiscount
        open={createDiscountOpen}
        closeCreateDiscountDialog={closeCreateDiscountDialog}
        setUserDiscounts={setUserDiscounts}
        userDTO={userDTO}
        userDiscounts={userDiscounts}
        editDiscounts={editDiscounts}
        />
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </TabPanel>
  );
};

export default AdminUsers;
